// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2DVFf","imageUploader":"EGiftCard_imageUploader__eWUgC"};